import { useHasAccess } from 'core/user/role';
import { useUser } from 'core/user/user';
import { SHARE_LEVEL } from 'models/shareLevel';

const useCanEditProject = (projectDetails) => {
  const { user } = useUser();
  const { hasAdminAccess, hasEditAccess } = useHasAccess();

  return (
    !projectDetails?.isFinal &&
    (hasAdminAccess() ||
      (hasEditAccess() && (projectDetails?.userId === user.id || projectDetails?.sharedLevel === SHARE_LEVEL.edit)))
  );
};

export default useCanEditProject;
